import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "font-medium capitalize" }
const _hoisted_5 = { class: "font-medium text-right capitalize" }
const _hoisted_6 = { class: "flex justify-between" }
const _hoisted_7 = { class: "font-medium capitalize" }
const _hoisted_8 = { class: "text-right" }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex justify-between" }
const _hoisted_12 = { class: "font-medium capitalize" }
const _hoisted_13 = { class: "font-medium text-right capitalize" }
const _hoisted_14 = { class: "flex justify-between" }
const _hoisted_15 = { class: "font-medium capitalize" }
const _hoisted_16 = { class: "text-right" }
const _hoisted_17 = { class: "flex justify-between" }
const _hoisted_18 = { class: "font-medium capitalize" }
const _hoisted_19 = { class: "text-right" }
const _hoisted_20 = { class: "flex justify-between" }
const _hoisted_21 = { class: "font-medium capitalize" }
const _hoisted_22 = { class: "text-right" }
const _hoisted_23 = { class: "flex justify-between" }
const _hoisted_24 = { class: "font-medium capitalize" }
const _hoisted_25 = { class: "text-right" }
const _hoisted_26 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_27 = { class: "font-medium capitalize" }
const _hoisted_28 = { class: "text-right" }
const _hoisted_29 = {
  key: 1,
  class: "flex justify-between"
}
const _hoisted_30 = { class: "font-medium capitalize" }
const _hoisted_31 = { class: "text-right" }
const _hoisted_32 = { class: "flex justify-between" }
const _hoisted_33 = { class: "font-medium capitalize" }
const _hoisted_34 = { class: "text-right capitalize" }
const _hoisted_35 = { class: "flex justify-between pt-4 mt-4 border-t border-gray-300" }
const _hoisted_36 = { class: "font-medium" }
const _hoisted_37 = {
  key: 0,
  class: "text-right uppercase"
}
const _hoisted_38 = {
  key: 1,
  class: "text-right uppercase"
}
const _hoisted_39 = {
  key: 2,
  class: "flex justify-between border-gray-300"
}
const _hoisted_40 = { class: "font-medium" }
const _hoisted_41 = { class: "text-right uppercase" }
const _hoisted_42 = {
  key: 3,
  class: "flex justify-between border-gray-300"
}
const _hoisted_43 = { class: "font-medium" }
const _hoisted_44 = { class: "text-right uppercase" }
const _hoisted_45 = {
  key: 4,
  class: "flex justify-between"
}
const _hoisted_46 = { class: "font-medium capitalize" }
const _hoisted_47 = { class: "text-right uppercase" }
const _hoisted_48 = { class: "flex justify-between" }
const _hoisted_49 = { class: "font-medium capitalize" }
const _hoisted_50 = {
  key: 0,
  class: "text-right uppercase"
}
const _hoisted_51 = {
  key: 1,
  class: "text-right uppercase"
}
const _hoisted_52 = { class: "flex justify-between" }
const _hoisted_53 = { class: "font-medium capitalize" }
const _hoisted_54 = { class: "text-right uppercase" }
const _hoisted_55 = {
  key: 5,
  style: {"margin-top":"20px"},
  class: "flex justify-between"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", {
  style: {"color":"red"},
  class: "font-medium"
}, [
  /*#__PURE__*/_createElementVNode("i", null, "Discounts are already applied above")
], -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", { class: "text-right uppercase" }, null, -1)
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "flex justify-between" }
const _hoisted_61 = { class: "font-medium capitalize" }
const _hoisted_62 = { class: "font-medium text-right capitalize" }
const _hoisted_63 = { class: "flex justify-between" }
const _hoisted_64 = { class: "font-medium capitalize" }
const _hoisted_65 = { class: "text-right" }
const _hoisted_66 = { class: "flex justify-between" }
const _hoisted_67 = { class: "font-medium capitalize" }
const _hoisted_68 = { class: "text-right" }
const _hoisted_69 = { class: "flex justify-between" }
const _hoisted_70 = { class: "font-medium capitalize" }
const _hoisted_71 = { class: "text-right" }
const _hoisted_72 = { class: "flex justify-between" }
const _hoisted_73 = { class: "font-medium capitalize" }
const _hoisted_74 = { class: "text-right" }
const _hoisted_75 = { class: "flex justify-between" }
const _hoisted_76 = { class: "font-medium capitalize" }
const _hoisted_77 = { class: "text-right capitalize" }
const _hoisted_78 = { class: "flex justify-between pt-4 mt-4 border-t border-gray-300" }
const _hoisted_79 = { class: "font-medium" }
const _hoisted_80 = { class: "text-right uppercase" }
const _hoisted_81 = { class: "flex justify-between border-gray-300" }
const _hoisted_82 = { class: "font-medium" }
const _hoisted_83 = { class: "text-right uppercase" }
const _hoisted_84 = { class: "flex justify-between" }
const _hoisted_85 = { class: "font-medium capitalize" }
const _hoisted_86 = { class: "text-right uppercase" }
const _hoisted_87 = { class: "flex justify-between" }
const _hoisted_88 = { class: "font-medium capitalize" }
const _hoisted_89 = {
  key: 0,
  class: "text-right uppercase"
}
const _hoisted_90 = {
  key: 1,
  class: "text-right uppercase"
}
const _hoisted_91 = { class: "flex justify-between" }
const _hoisted_92 = { class: "font-medium capitalize" }
const _hoisted_93 = { class: "text-right uppercase" }
const _hoisted_94 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_95 = { class: "font-medium capitalize" }
const _hoisted_96 = { key: 2 }
const _hoisted_97 = { class: "flex justify-between" }
const _hoisted_98 = { class: "font-medium capitalize" }
const _hoisted_99 = { class: "font-medium text-right capitalize" }
const _hoisted_100 = { class: "flex justify-between" }
const _hoisted_101 = { class: "font-medium capitalize" }
const _hoisted_102 = { class: "text-right" }
const _hoisted_103 = { class: "flex justify-between" }
const _hoisted_104 = { class: "font-medium capitalize" }
const _hoisted_105 = { class: "text-right capitalize" }
const _hoisted_106 = { class: "flex justify-between" }
const _hoisted_107 = { class: "font-medium capitalize" }
const _hoisted_108 = { class: "text-right capitalize" }
const _hoisted_109 = { key: 3 }
const _hoisted_110 = { class: "flex justify-between" }
const _hoisted_111 = { class: "font-medium capitalize" }
const _hoisted_112 = { class: "font-medium text-right capitalize" }
const _hoisted_113 = { class: "flex justify-between" }
const _hoisted_114 = { class: "font-medium capitalize" }
const _hoisted_115 = { class: "font-medium text-right" }
const _hoisted_116 = { class: "flex justify-between" }
const _hoisted_117 = { class: "font-medium capitalize" }
const _hoisted_118 = { class: "text-right" }

import { PropType } from "vue";
import { Booking, Event, Transaction } from "@/types";
import { storeToRefs } from "pinia";
import { useUserStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDetailsCard',
  props: {
  booking: {
    type: Object as PropType<Booking>,
    required: true,
  },
  event: {
    type: Object as PropType<Event>,
    required: true,
  },
  group: {
    type: Object as PropType<any> | null,
    required: false,
  },
  transactionGroup: {
    type: Array as PropType<Transaction[]>,
    required: true,
  },
  subscription: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props;

const { user } = storeToRefs(useUserStore());


function intlFormat(value: number) {
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: props.booking.transaction ? props.booking.transaction.currency : "GBP" }).format(value);
}

function calculateTotal(booking: Booking) {
  if (props.booking.transaction.payment_gateway === "2Checkout") {
    let total = Number(booking.invoice_total_amount);

    if (booking.subscription_count > 0 && !props.group) {
      const subscription_total = Number(booking.subscription_amount) * Number(booking.subscription_count > 0 ? booking.subscription_count : 1);
      total += Number(subscription_total);
    }

    if (props.group && props.group.booking.subscription_amount > 0) {
      const subscription_total = Number(props.group.booking.subscription_amount);
      total += Number(subscription_total);
    }

    if (booking.invoice_tax_amount > 0) {
      total += Number(booking.invoice_tax_amount);
    }

    return total;
  } else {
    //Add together the net_price of all items in the transactionGroup
    var totalFees = 0;
    props.transactionGroup.forEach(transaction => {
      totalFees += Number(transaction.net_price);
    });

    //Add together the vat of all items in the transactionGroup
    var totalVat = 0;
    props.transactionGroup.forEach(transaction => {
      totalVat += Number(transaction.vat);
    });

    return totalFees + totalVat;
  }
}

function calculateMembershipsTotal() {
  const percent_amount = props.booking.transaction.discount ? props.booking.transaction.discount.percent_amount : 0;
  const discountDivisor = 100 - Number(percent_amount);

  if (props.group) {
    const membership = props.group.booking.subscription_amount * (100 / discountDivisor);

    if (props.group && props.group.booking && props.group.booking.subscription_amount) {
      return membership;
    }
  }

  const membership = props.booking.subscription_amount * (100 / discountDivisor);

  return membership || 0;
}

function calculateDiscount(net_price: Number, percent_amount: Number) {
  const original_net_price = calculateOriginalNetPrice(net_price);

  const net_price_plus_membership = Number(original_net_price) + calculateMembershipsTotal();
  return intlFormat(net_price_plus_membership * (Number(percent_amount) / 100));
}

function calculateOriginalNetPrice(net_price: Number) {
  if (props.booking.transaction.payment_gateway === "2Checkout") {
    return Number(net_price);
  }
  const percent_amount = props.booking.transaction.discount ? props.booking.transaction.discount.percent_amount : 0;

  const discountDivisor = 100 - Number(percent_amount);
  const net_priceMultiplied = Number(net_price) * 100;

  let original_net_price = net_priceMultiplied / discountDivisor;

  if (props.group) {
    original_net_price = original_net_price - calculateMembershipsTotal();
  }

  return original_net_price;
}

// function calculateOriginalNetPriceForCoursesOnly(net_price: Number) {
//   if (props.booking.transaction.payment_gateway === '2Checkout') {
//     return Number(net_price);
//   }
//   const percent_amount = props.booking.transaction.discount ? props.booking.transaction.discount.percent_amount : 0;

//   const discountDivisor = 100 - Number(percent_amount);
//   const net_priceMultiplied = Number(net_price) * 100;

//   let original_net_price = net_priceMultiplied / discountDivisor;

//   return original_net_price;
// }

// function calculateTaxForUKCardGroup(booking: Booking) {
//   console.log("calculateTaxForUKCardGroup");
//   const net_total = Number(booking.transaction.net_price);
//   const overall_total = net_total + Number(booking.transaction.vat);
//   console.log("net_total " + net_total);
//   const tax_rate = 100 * (Number(overall_total) / Number(net_total)) - 100;
//   console.log("tax_rate " + tax_rate);
//   return "(" + tax_rate.toFixed(2) + "%)" || "0%)";
// }

function calculateTaxForCard(booking: Booking) {
  return "(" + Number(booking.transaction.tax_percent).toFixed(2) + "%)" || "0%)";
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_RoleGuard = _resolveComponent("RoleGuard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ((__props.booking.type === 'group' && !__props.event.payment_gateway) || __props.booking.addedByUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("group-booking-financial-information")), 1)
        ]))
      : _createCommentVNode("", true),
    (!__props.booking.transaction)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("tr", _hoisted_3, [
            _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.$t("status")) + ":", 1),
            _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.$t(__props.booking.payment_status)), 1)
          ]),
          _createElementVNode("tr", _hoisted_6, [
            _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.$t("payment-method")) + ":", 1),
            _createElementVNode("td", _hoisted_8, _toDisplayString(__props.booking.payment_method) + " (" + _toDisplayString(__props.booking.payment_gateway) + ")", 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (__props.booking.payment_method === 'Credit/Debit Card')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("tr", _hoisted_11, [
                  _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$t("status")) + ":", 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.$t(__props.booking.payment_status)), 1)
                ]),
                _createElementVNode("tr", _hoisted_14, [
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.$t("payment-method")) + ":", 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(__props.booking.payment_method) + " " + _toDisplayString(__props.booking.transaction ? `(${__props.booking.transaction.payment_gateway})` : ""), 1)
                ]),
                _createElementVNode("tr", _hoisted_17, [
                  _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.$t("payment-gateway-order-id")) + ":", 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(__props.booking.transaction.order_id), 1)
                ]),
                _createElementVNode("tr", _hoisted_20, [
                  _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.$t("payment-gateway-customer-id")) + ":", 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(__props.booking.user.stripe_customer_id), 1)
                ]),
                _createElementVNode("tr", _hoisted_23, [
                  _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.$t("affiliate-id")) + ":", 1),
                  _createElementVNode("td", _hoisted_25, _toDisplayString(__props.booking.transaction.affiliate_id ? __props.booking.transaction.affiliate_id : ``), 1)
                ]),
                (__props.booking.transaction && __props.booking.transaction.discount)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                      _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.$t("discount-code")) + ":", 1),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(__props.booking.transaction.discount.name) + " (" + _toDisplayString(__props.booking.transaction.discount.percent_amount ?? 0) + "%)", 1)
                    ]))
                  : _createCommentVNode("", true),
                (__props.booking.transaction && __props.booking.transaction.payment_gateway === '2Checkout')
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                      _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.$t("product-code")) + ":", 1),
                      _createElementVNode("td", _hoisted_31, _toDisplayString(__props.booking.transaction.payment_gateway_product_code), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", _hoisted_32, [
                  _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.$t("funds-recieved")) + ":", 1),
                  _createElementVNode("td", _hoisted_34, _toDisplayString(__props.booking.transaction.funds_received_at ? new Date(__props.booking.transaction.funds_received_at).toLocaleDateString() : _ctx.$t("not-received")), 1)
                ]),
                _createElementVNode("tr", _hoisted_35, [
                  _createElementVNode("td", _hoisted_36, [
                    _createTextVNode(_toDisplayString(_ctx.$t("payment-amount")) + " ", 1),
                    _createElementVNode("strong", null, "(Courses x " + _toDisplayString(__props.group && __props.group.booking ? __props.group.booking.course_count : __props.booking.course_count) + ")", 1),
                    _createTextVNode(": ")
                  ]),
                  (__props.booking.transaction.discount)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_37, _toDisplayString(intlFormat(calculateOriginalNetPrice(__props.booking.transaction.net_price))) + " " + _toDisplayString(__props.booking.transaction.currency || "GBP"), 1))
                    : _createCommentVNode("", true),
                  (!__props.booking.transaction.discount)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_38, _toDisplayString(intlFormat(__props.booking.transaction.net_price)) + " " + _toDisplayString(__props.booking.transaction.currency || "GBP"), 1))
                    : _createCommentVNode("", true)
                ]),
                (__props.booking.transaction.payment_gateway === 'Stripe')
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                      _createElementVNode("td", _hoisted_40, [
                        _createTextVNode(" Membership "),
                        _createElementVNode("strong", null, "(x " + _toDisplayString(__props.group && __props.group.booking ? __props.group.booking.subscription_count : __props.booking.subscription_count) + ")", 1)
                      ]),
                      _createElementVNode("td", _hoisted_41, _toDisplayString(intlFormat(calculateMembershipsTotal())) + " " + _toDisplayString(__props.booking.invoice_currency || "GBP"), 1)
                    ]))
                  : _createCommentVNode("", true),
                (__props.booking.transaction.payment_gateway === '2Checkout')
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [
                      _createElementVNode("td", _hoisted_43, [
                        _createTextVNode(" Membership "),
                        _createElementVNode("strong", null, "(x " + _toDisplayString(__props.group && __props.group.booking ? __props.group.booking.subscription_count : __props.booking.subscription_count) + ")", 1)
                      ]),
                      _createElementVNode("td", _hoisted_44, _toDisplayString(intlFormat(__props.group && __props.group.booking ? __props.group.booking.subscription_amount : __props.booking.subscription_amount)) + " " + _toDisplayString(__props.booking.invoice_currency || "GBP"), 1)
                    ]))
                  : _createCommentVNode("", true),
                (__props.booking.transaction && __props.booking.transaction.discount && __props.booking.transaction.payment_gateway !== '2Checkout')
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [
                      _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.$t("discount-amount")) + ":", 1),
                      _createElementVNode("td", _hoisted_47, " - " + _toDisplayString(calculateDiscount(__props.booking.transaction.net_price, __props.booking.transaction.discount.percent_amount)) + " (" + _toDisplayString(__props.booking.transaction.discount.percent_amount ?? 0) + "%) " + _toDisplayString(__props.booking.invoice_currency || "GBP"), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", _hoisted_48, [
                  _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.$t("tax")) + ":", 1),
                  (Number(__props.booking.invoice_tax_amount) >= 0)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_50, _toDisplayString(intlFormat(__props.booking.invoice_tax_amount)) + " " + _toDisplayString(calculateTaxForCard(__props.booking)) + " " + _toDisplayString(__props.booking.transaction ? __props.booking.transaction.currency : "GBP"), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_51, "TBC"))
                ]),
                _createElementVNode("tr", _hoisted_52, [
                  _createElementVNode("td", _hoisted_53, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t("total")) + ":", 1)
                  ]),
                  _createElementVNode("td", _hoisted_54, [
                    _createElementVNode("strong", null, _toDisplayString(intlFormat(calculateTotal(__props.booking))) + " " + _toDisplayString(__props.booking.transaction ? __props.booking.transaction.currency : "GBP"), 1)
                  ])
                ]),
                (__props.booking.transaction && __props.booking.transaction.discount && __props.booking.transaction.payment_gateway === '2Checkout')
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_55, _hoisted_58))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (__props.booking.payment_method === 'Invoice' && !__props.event.payment_gateway)
            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                _createElementVNode("tr", _hoisted_60, [
                  _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.$t("status")) + ":", 1),
                  _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.$t(__props.booking.payment_status)), 1)
                ]),
                _createElementVNode("tr", _hoisted_63, [
                  _createElementVNode("td", _hoisted_64, _toDisplayString(_ctx.$t("payment-method")) + ":", 1),
                  _createElementVNode("td", _hoisted_65, _toDisplayString(_ctx.$t("invoice")), 1)
                ]),
                _createElementVNode("tr", _hoisted_66, [
                  _createElementVNode("td", _hoisted_67, _toDisplayString(_ctx.$t("tax-registration-number")) + ":", 1),
                  _createElementVNode("td", _hoisted_68, _toDisplayString(__props.booking.tax_registration_number), 1)
                ]),
                _createElementVNode("tr", _hoisted_69, [
                  _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.$t("purchase-order-number")) + ":", 1),
                  _createElementVNode("td", _hoisted_71, _toDisplayString(__props.booking.purchase_order_number), 1)
                ]),
                _createElementVNode("tr", _hoisted_72, [
                  _createElementVNode("td", _hoisted_73, _toDisplayString(_ctx.$t("discount-code")) + ":", 1),
                  _createElementVNode("td", _hoisted_74, _toDisplayString(__props.group && __props.group.booking ? __props.group.booking.discount_code : __props.booking.discount_code), 1)
                ]),
                _createElementVNode("tr", _hoisted_75, [
                  _createElementVNode("td", _hoisted_76, _toDisplayString(_ctx.$t("funds-recieved")) + ":", 1),
                  _createElementVNode("td", _hoisted_77, _toDisplayString(__props.booking.transaction.funds_received_at
              ? new Date(__props.booking.transaction.funds_received_at).toLocaleDateString()
              : __props.booking.funds_received_at
              ? new Date(__props.booking.funds_received_at).toLocaleDateString()
              : _ctx.$t("not-received")), 1)
                ]),
                _createElementVNode("tr", _hoisted_78, [
                  _createElementVNode("td", _hoisted_79, [
                    _createTextVNode(_toDisplayString(__props.booking.event!.name) + " ", 1),
                    _createElementVNode("strong", null, "(x " + _toDisplayString(__props.group && __props.group.booking ? __props.group.booking.course_count : __props.booking.course_count) + ")", 1)
                  ]),
                  _createElementVNode("td", _hoisted_80, _toDisplayString(intlFormat(__props.booking.transaction.price_summary ? __props.booking.transaction.price_summary.TotalCourseNetPriceBeforeDiscounts : 0)) + " " + _toDisplayString(__props.booking.invoice_currency || "GBP"), 1)
                ]),
                _createElementVNode("tr", _hoisted_81, [
                  _createElementVNode("td", _hoisted_82, [
                    _createTextVNode(" Membership "),
                    _createElementVNode("strong", null, "(x " + _toDisplayString(__props.group && __props.group.booking ? __props.group.booking.subscription_count : __props.booking.subscription_count) + ")", 1)
                  ]),
                  _createElementVNode("td", _hoisted_83, _toDisplayString(intlFormat(__props.booking.transaction.price_summary ? __props.booking.transaction.price_summary.TotalSubscriptionNetPriceBeforeDiscounts : 0)) + " " + _toDisplayString(__props.booking.invoice_currency || "GBP"), 1)
                ]),
                _createElementVNode("tr", _hoisted_84, [
                  _createElementVNode("td", _hoisted_85, _toDisplayString(_ctx.$t("discount-amount")) + ":", 1),
                  _createElementVNode("td", _hoisted_86, _toDisplayString(intlFormat(__props.booking.transaction.price_summary ? __props.booking.transaction.price_summary.TotalDiscount : 0)) + " " + _toDisplayString(__props.booking.invoice_currency || "GBP"), 1)
                ]),
                _createElementVNode("tr", _hoisted_87, [
                  _createElementVNode("td", _hoisted_88, _toDisplayString(_ctx.$t("tax")) + ":", 1),
                  (Number(__props.booking.transaction.vat) >= 0)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_89, _toDisplayString(intlFormat(__props.booking.transaction.price_summary ? __props.booking.transaction.price_summary.TotalVAT : 0)) + " " + _toDisplayString(__props.booking.invoice_currency ? __props.booking.invoice_currency : "GBP") + " " + _toDisplayString(__props.booking.transaction.price_summary ? "(" + __props.booking.transaction.price_summary.VATPercent + "%)" : 0), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_90, "TBC"))
                ]),
                _createElementVNode("tr", _hoisted_91, [
                  _createElementVNode("td", _hoisted_92, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t("total")) + ":", 1)
                  ]),
                  _createElementVNode("td", _hoisted_93, [
                    _createElementVNode("strong", null, _toDisplayString(intlFormat(__props.booking.transaction.price_summary ? __props.booking.transaction.price_summary.TotalGrossPrice : 0)) + " " + _toDisplayString(__props.booking.invoice_currency || "GBP"), 1)
                  ])
                ]),
                (__props.transactionGroup.length > 1)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_94, [
                      _createElementVNode("td", _hoisted_95, _toDisplayString(_ctx.$t("annual-subscriptions")) + ":", 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          to: `/dashboard/orders/subscriptions/${__props.subscription}`,
                          class: "text-blue-500"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("view-subscription")), 1)
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (__props.booking.payment_method === 'License')
            ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                _createElementVNode("tr", _hoisted_97, [
                  _createElementVNode("td", _hoisted_98, _toDisplayString(_ctx.$t("status")) + ":", 1),
                  _createElementVNode("td", _hoisted_99, _toDisplayString(_ctx.$t(__props.booking.payment_status)), 1)
                ]),
                _createElementVNode("tr", _hoisted_100, [
                  _createElementVNode("td", _hoisted_101, _toDisplayString(_ctx.$t("payment-method")) + ":", 1),
                  _createElementVNode("td", _hoisted_102, _toDisplayString(_ctx.$t("redeemed-license")), 1)
                ]),
                _createVNode(_component_RoleGuard, { roles: ['admin', 'users-admin', 'courses-admin', 'clubs-admin'] }, {
                  default: _withCtx(() => [
                    _createElementVNode("tr", _hoisted_103, [
                      _createElementVNode("td", _hoisted_104, _toDisplayString(_ctx.$t("license-id")) + ":", 1),
                      _createElementVNode("td", _hoisted_105, [
                        _createVNode(_component_RouterLink, {
                          class: "text-blue-500 underline",
                          to: { name: 'Licence', params: { lid: __props.booking.license?.id, oid: __props.booking.license?.organisation_id } }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" #" + _toDisplayString(__props.booking.license?.id), 1)
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("tr", _hoisted_106, [
                  _createElementVNode("td", _hoisted_107, _toDisplayString(_ctx.$t("added-by")) + ":", 1),
                  _createElementVNode("td", _hoisted_108, [
                    _createVNode(_component_RouterLink, {
                      class: "text-blue-500 underline",
                      to: { name: 'User_Profile', params: { id: __props.booking.addedByUser?.id } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.booking.addedByUser?.first_name) + " " + _toDisplayString(__props.booking.addedByUser?.last_name), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (__props.booking.payment_gateway !== null && __props.event.payment_gateway && _unref(user).id === __props.event.user_id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                _createElementVNode("tr", _hoisted_110, [
                  _createElementVNode("td", _hoisted_111, _toDisplayString(_ctx.$t("status")) + ":", 1),
                  _createElementVNode("td", _hoisted_112, _toDisplayString(_ctx.$t(__props.booking.payment_status)), 1)
                ]),
                _createElementVNode("tr", _hoisted_113, [
                  _createElementVNode("td", _hoisted_114, _toDisplayString(_ctx.$t("payment-method")) + ":", 1),
                  _createElementVNode("td", _hoisted_115, _toDisplayString(__props.booking.payment_method === "Invoice" ? "Invoice" : __props.event.payment_gateway), 1)
                ]),
                _createElementVNode("tr", _hoisted_116, [
                  _createElementVNode("td", _hoisted_117, _toDisplayString(_ctx.$t("funds-recieved")) + ":", 1),
                  _createElementVNode("td", _hoisted_118, _toDisplayString(__props.booking.transaction.funds_received_at ? new Date(__props.booking.transaction.funds_received_at).toLocaleDateString() : _ctx.$t("not-received")), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 64))
}
}

})